var BlockView = require('views/block/base-block-view');
var MatchingSelectionQuestionView = require('views/block/game/matching-selection-question-view');
var TapSelectionQuestionView = require('views/block/game/tap-selection-question-view');
var MultiTapSelectionQuestionView = require('views/block/game/multi-tap-selection-question-view');
var TimedSelectionQuestionView = require('views/block/game/timed-selection-question-view');
var TapAndDropQuestionView = require('views/block/game/tap-and-drop-question-view');
var FeedbackService = require('services/feedback-service');
var AssessmentService = require('services/assessment-service');
var ScoreService = require('services/score-service');
var TimeoutService = require('services/timeout-service');
var LocaleService = require('services/locale-service');
const AhoyService = require('services/ahoy-service');

let GameView = BlockView.extend({
  regions: {
    question: '.game-container',
  },
  defaultSettings: {
    interval_speed: 1000,
    level_delay: 0,
    question_delay: 0,
    require_correct: false,
    question_timeout: -1,
    randomize_question_order: false,
    randomize_answer_order: false,
    button_text: 'SUBMIT',
    alt_progress: false,
    progress_on_answer: false,
  },
  levelIdArray: [],
  currentLevel: undefined,
  currentQuestionView: undefined,
  questionIterator: 0,
  totalQuestions: 0,
  questionArray: [],
  levelQuestionArray: [],
  assessment: undefined,
  answerFeedback: undefined,

  initialize: function () {
    // initialize the global activity settings
    this.activitySettings = _.defaults(this.model.get('game_settings'), this.defaultSettings);
    this.levelIdArray = _.cloneDeep(
      Array.isArray(this.model.get('level_id')) ? this.model.get('level_id') : [this.model.get('level_id')]
    );
    BlockView.prototype.initialize.apply(this, arguments);
    ScoreService.init(this.model.get('score_settings') ? this.model.get('score_settings') : {});
  },

  dispose: function () {
    ScoreService.clearTimer();
    BlockView.prototype.dispose.apply(this, arguments);
  },

  load: function () {
    if (this.model.get('assessment_slug') !== undefined) {
      this.setAssessment();
    } else {
      this.loadQuestions();
    }
  },

  // load assessment slug data
  setAssessment: function () {
    this.assessment = AssessmentService.getAssessment(this.model.get('assessment_slug'));
    this.listenTo(this.assessment, 'assessments:load', this.onAssessmentLoad.bind(this));
    this.assessment.loadAssessment({});
  },

  // on assessment data load
  onAssessmentLoad: function () {
    let questions = [];
    this.assessment.get('questions').models.forEach(function (q) {
      questions.push(q.attributes);
    });
    this.questionArray = _.cloneDeep(questions);
    this.setLevel();
  },

  loadQuestions: function () {
    this.questionArray = _.cloneDeep(this.model.get('game_questions'));
    this.questionArray.forEach(q => {
      q.text = LocaleService.t(q.text);
      q.answers.forEach(a => {
        a.text = LocaleService.t(a.text);
      });
    });
    this.setLevel();
  },

  // set level question data
  setLevel: function () {
    ScoreService.resetChainBonus();
    let level = (this.currentLevel = this.levelIdArray.shift());
    this.levelQuestionArray = this.initializeQuestions(
      _.filter(this.questionArray, q => {
        return q.level_id === level;
      }),
      this.activitySettings
    );
    this.totalQuestions = this.levelQuestionArray.length;
    this.questionIterator = 0;

    if (this.activitySettings.level_delay > 0) {
      if (this.currentQuestionView) {
        this.currentQuestionView.dispose();
      }
      this.setProgressBar(-1);
      this.firstQuestionDelay = new TimeoutService(this.activitySettings.level_delay, () => {
        this.setQuestion();
      });
      this.firstQuestionDelay.play();
    } else {
      this.setQuestion();
    }

    Chaplin.mediator.publish('game:level:loaded', { level: level });
    ScoreService.setElementValues(level);
  },

  // ingest question data based on activity settings
  initializeQuestions: function (qModel, activitySettings) {
    qModel.forEach((question, index) => {
      question.id = index;
      let answers = question.answers;
      if (activitySettings.randomize_answer_order) {
        answers = _.shuffle(answers);
      }
      question.answers = answers;
      if (!question.button_text) {
        question.button_text = activitySettings.button_text;
      }
      question.activitySettings = activitySettings;
      question.regions = this.regions;
    });
    if (activitySettings.randomize_question_order) {
      qModel = _.shuffle(qModel);
    }
    return qModel;
  },

  // sets/renders a question based on the current position of the question iterator
  setQuestion: function () {
    this.currentQuestion = this.levelQuestionArray[0];
    this.currentQuestion.blocks = this.model.get('question_blocks');
    this.setProgressBar(this.questionIterator);
    let questionView;
    switch (this.model.get('game_type')) {
      case 'timed-selection':
        questionView = new TimedSelectionQuestionView({
          model: new Chaplin.Model(this.currentQuestion),
          region: 'question',
        });
        break;
      case 'tap-and-drop':
        questionView = new TapAndDropQuestionView({
          model: new Chaplin.Model(this.currentQuestion),
          region: 'question',
        });
        break;

      case 'tap-selection':
        questionView = new TapSelectionQuestionView({
          model: new Chaplin.Model(this.currentQuestion),
          region: 'question',
        });
        break;

      case 'multi-tap-selection':
        questionView = new MultiTapSelectionQuestionView({
          model: new Chaplin.Model(this.currentQuestion),
          region: 'question',
        });
        break;

      case 'matching-selection':
        questionView = new MatchingSelectionQuestionView({
          model: new Chaplin.Model(this.currentQuestion),
          region: 'question',
        });
        break;
      default:
        break;
    }
    this.subview('question', questionView);
    if (this.currentQuestion.blocks) {
      this.renderNestedBlocks('question-blocks', this.currentQuestion.blocks);

      if (this.model.get('state') === 'playing') {
        let subviews = this.subviewsByName['question-blocks'];
        subviews.stateChange(this);
      }
    }

    questionView.on('question:answered', params => {
      this.questionAnswered(params);
    });
    questionView.on('question:feedback', params => {
      this.showFeedback(params);
    });
    questionView.on('question:timeout', params => {
      this.questionTimeout(params);
    });
    questionView.load();

    this.currentQuestionView = questionView;

    Chaplin.mediator.publish('game:question:loaded');
    ScoreService.start();
  },

  setProgressBar: function (val) {
    var p = Math.round((val / this.totalQuestions) * 100);
    if (p > 100) p = 100;
    $('.game-progress .progress-bar').css('width', p + '%');

    if (this.activitySettings.alt_progress) {
      $('.game-progress .progress-bar .label').html(p + '%');
    } else {
      $('.game-progress .progress-bar .label').html(val + '/' + this.totalQuestions);
    }
  },

  // updates the question iterator and sets the question
  nextQuestion: function (correct) {
    if ((this.activitySettings.require_correct && correct) || !this.activitySettings.require_correct) {
      this.questionIterator++;
      this.levelQuestionArray.shift();
    } else {
      if (this.activitySettings.randomize_question_order) {
        if (this.activitySettings.randomize_answer_order) {
          this.levelQuestionArray[0].answers = _.shuffle(this.levelQuestionArray[0].answers);
        }
        let q = this.levelQuestionArray.shift();
        this.levelQuestionArray = _.shuffle(this.levelQuestionArray);
        this.levelQuestionArray.push(q);
      }
    }
    this.setQuestion();
  },

  // the user took too long to answer the question
  questionTimeout: function (params) {
    this.showFeedback({
      correct: false,
      answerElement: params.answerElement,
      feedback: params.feedback,
    });
    Chaplin.mediator.publish('game:question:timeout');
  },

  // fire a publish event after question answered
  questionAnswered: function (params) {
    ScoreService.update({ correct: params.correct, level: this.currentLevel, type: this.model.get('game_type') });
    ScoreService.pause();
    params.score = ScoreService.getScore();
    Chaplin.mediator.publish('game:question:answered', params);
    AhoyService.track('game', { action: 'questionAnswered', params: params });
    if (this.activitySettings.progress_on_answer) {
      if ((this.activitySettings.require_correct && params.correct) || !this.activitySettings.require_correct) {
        this.setProgressBar(this.questionIterator + 1);
      }
    }
  },

  // show feedback based on params the answer is correct or not
  showFeedback: function (params) {
    let correct = params.correct;
    let answerElement = params.answerElement;
    let feedback = this.model.get('game_feedback');
    let feedbackState = correct ? 'correct' : 'incorrect';

    if (feedback) {
      if (correct) {
        feedback.correct.blocks.forEach(b => {
          if (b.description) {
            b.description = this.currentQuestion.correct_feedback;
          }
        });
      } else {
        feedback.incorrect.blocks.forEach(b => {
          if (b.description) {
            b.description = this.currentQuestion.incorrect_feedback;
          }
        });
      }
    }

    let possibleStates = ['correct', 'incorrect'];
    let complete = () => {
      this.checkCompletion(correct);
    };
    FeedbackService.renderFeedbackWithElementState(feedback, answerElement, feedbackState, possibleStates, {
      completed: complete,
      noFeedback: _.bind(complete, this),
    });

    Chaplin.mediator.publish('game:question:feedback', {
      correct: correct,
    });
  },

  // have we completed the whole activity?
  checkCompletion: function (correct) {
    if ((this.activitySettings.require_correct && correct) || !this.activitySettings.require_correct) {
      if (this.questionIterator + 1 === this.totalQuestions) {
        if (this.levelIdArray.length > 0) {
          this.setLevel();
        } else {
          this.endActivity();
        }
      } else {
        $('.game-container').removeClass('unanswered answered correct incorrect');
        this.nextQuestion(correct);
      }
    } else {
      this.nextQuestion(correct);
    }
  },

  // done with the activity
  endActivity: function () {
    this.setProgressBar(this.totalQuestions);
    AhoyService.track('game', { action: 'completed' });
    this.readyToGo();
    Chaplin.mediator.publish('game:activity:ended');
  },
});

export default GameView;
